// Constants

export const liquidacion_devengados = () => {
    return {
        liquidacion_devengados: {
            id: {
                namepath: ["afiliado_liquidacion"],
                description: 'id autoincrement',
                label: 'Id',
                name: 'solId',
                readonly: true,
                type: 'number',
                datatype: {
                    predeterminate: ''
                }
            },
            id_info_liquidacion: {
                namepath: ["afiliado_liquidacion"],
                type: 'input',
                label: '',
                name: '',
                placeholder: '',
                description: 'Nombre de la razón',
                validate: 'required',
                datatype: {
                    basico: true,
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                    label: ''
                },
            },
            concepto: {
                type: "text",
                label: "Gastos Menores",
                placeholder: "",
                namepath: ["afiliado_liquidacion"],
                description: "",
                validate: "",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: "",
                }
            },
            valor: {
                type: "number",
                label: "Valor",
                placeholder: "",
                namepath: ["afiliado_liquidacion"],
                description: "",
                validate: "",
                datatype: {
                    type: "price",
                    disabled: false,
                    predeterminate: 0,
                    prepend: "$",
                }
            },
            predeterminado: {
                type: "number",
                label: "Valor",
                placeholder: "",
                namepath: ["afiliado_liquidacion"],
                description: "",
                validate: "",
                datatype: {
                    type: "price",
                    disabled: false,
                    predeterminate: 0,
                    prepend: "",
                }
            },
        }
    }
}